import { Image } from "../../components/Tickets/Image";


function TermsIcon(fluentuiImageProps: any) {
  return <Image alt="img" {...fluentuiImageProps} />;
}

export default TermsIcon;
